<template>
    <div>
        <api-search
            class="w-100"
            :route="'enquiries/fragment/parts/searchParts'"
            :autocomplete-css="'max-height: 254px;'"
            :placeholder="'Search for existing part'"
            :initial-query="partNo"
            name="partNo"
        >
            <template v-slot="row">
                <div
                    class="dropdown-item d-flex"
                    :class="row.item.exact ? 'part-exact' : ''"
                >
                    <div
                        class="flex-grow-1 align-self-stretch btn-a"
                        style="width: 50%;"
                        @click="partClick(row.item.ID, row.defocus)"
                    >
                        <div class="pb-1">{{ formatPartName(row.item) }}</div>
                        <div
                            class="text-muted text-truncate"
                            style="font-size: 9.5pt;"
                        >
                            {{ formatPartDesc(row.item) }}
                        </div>
                    </div>
                </div>
            </template>
        </api-search>
    </div>
</template>

<script>
export default {
    name: "AdminPartSearch",

    props: {
        partNo: String,
        route: String,
    },

    data() {
        return {};
    },

    computed: {},

    methods: {
        partClick(id) {
            window.open(this.route.replace("XXXXX", id));
        },

        formatPartName(part) {
            let text = part.manufacturer.manufacturerName + " " + part.partNo;
            return text.slice(0, 45) + (text.length > 45 ? "..." : "");
        },

        formatPartDesc(part) {
            let text = part.description;
            return text.charAt(0).toUpperCase() + text.slice(1);
        },
    },
};
</script>
